import { render, staticRenderFns } from "./MarkCornersPopup.vue?vue&type=template&id=d0fbddb8&scoped=true&"
import script from "./MarkCornersPopup.vue?vue&type=script&lang=js&"
export * from "./MarkCornersPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarkCornersPopup.vue?vue&type=style&index=0&id=d0fbddb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fbddb8",
  null
  
)

export default component.exports